// extracted by mini-css-extract-plugin
module.exports = {"component":"_3eMEm","footer":"_1Jzv9","error":"_3nxV8","errorHeader":"_2rd-c","errorBody":"_2wUAH","errorImage":"_1-161","fullScreen":"_36vka","noBranding":"_1FZAY"};